module.exports = __webpack_public_path__ + "static/media/16-luke-bday_09_26_2020.022ef789.jpg";